function toArray(object) {
    var arr = [];

    for(var key in object) {
        if (!object.hasOwnProperty(key)) continue;
        arr.push(object[key]);
    }

    return arr;
}

export default toArray;
